import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="text-lg font-semibold text-foreground-900 whitespace-nowrap">
              朋友的姐姐
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              探索青春懵懂情感，重温那段藏在心底的成长记忆。关注青春期情感心理，发现更美好的自己。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category/qinggan-gushi" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">
                  情感故事
                </Link>
              </li>
              <li>
                <Link to="/category/chengzhang-jiyi" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">
                  成长记忆
                </Link>
              </li>
              <li>
                <Link to="/category/xinli-fenxi" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">
                  心理分析
                </Link>
              </li>
              <li>
                <Link to="/category/qingchun-wenxue" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">
                  青春文学
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">
                  用户口碑
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">关注我们</h4>
            <p className="text-sm text-foreground-600 mb-4">
              订阅我们的Newsletter，获取最新文章和情感故事。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-full bg-background-100 flex items-center justify-center text-foreground-600 hover:bg-primary-100 hover:text-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-100 flex items-center justify-center text-foreground-600 hover:bg-primary-100 hover:text-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-100 flex items-center justify-center text-foreground-600 hover:bg-primary-100 hover:text-primary-500 transition-colors duration-200 cursor-pointer" aria-label="知乎">
                <i className="ri-zhihu-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 朋友的姐姐 - 青春情感记忆平台. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-primary-500 transition-colors duration-200">隐私政策</a>
            <a href="#" className="hover:text-primary-500 transition-colors duration-200">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}